import React, { useRef, useEffect, useState, useCallback } from 'react';

const DrawingBoard = ({ onPointsChange, width, height }) => {
  const canvasRef = useRef(null);
  const contextRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [points, setPoints] = useState({});
  const lastPointRef = useRef(null);


  const drawAxes = useCallback(() => {
    const ctx = contextRef.current;
    const axisColor = '#333';
    const tickSize = 10;
    const labelPaddingX = 10;
    const labelPaddingY = -35;
    const labelFrequency = 50;
    const y_axis_x_loc = 0;
    // const x_axis_y_loc = 0;
    const x_axis_y_loc = 0;

  
    // Reset transformation to the identity matrix
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  
    // Draw x-axis
    ctx.beginPath();
    ctx.moveTo(0, x_axis_y_loc);
    ctx.lineTo(width, x_axis_y_loc);
    ctx.strokeStyle = axisColor;
    ctx.stroke();
  
    // Draw y-axis
    ctx.beginPath();
    ctx.moveTo(y_axis_x_loc, 0);
    ctx.lineTo(y_axis_x_loc, height);
    ctx.strokeStyle = axisColor;
    ctx.stroke();
  
    // Draw x-axis tick marks and labels
    ctx.font = '11px Arial';
    ctx.fillStyle = axisColor;
    ctx.textAlign = 'center';
    for (let x = labelFrequency; x < width; x += labelFrequency) {
      ctx.beginPath();
      ctx.moveTo(x, x_axis_y_loc - tickSize / 2);
      ctx.lineTo(x, x_axis_y_loc + tickSize / 2);
      ctx.stroke();
      ctx.fillText(x - y_axis_x_loc, x, x_axis_y_loc + tickSize / 2 + 12 + labelPaddingX);
    }
  
    // Draw y-axis tick marks and labels
    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
    for (let y = labelFrequency; y < height; y += labelFrequency) {
      ctx.beginPath();
      ctx.moveTo(y_axis_x_loc - tickSize / 2, y);
      ctx.lineTo(y_axis_x_loc + tickSize / 2, y);
      ctx.stroke();
      ctx.fillText(y, y_axis_x_loc - tickSize / 2 - labelPaddingY, y);
    }
  
    // Restore the transformation to the original scale and translation
   ctx.setTransform(1, 0, 0, -1, 0, height);
  
  }, [height, width]);
  

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    context.lineCap = 'round';
    context.strokeStyle = 'black';
    context.lineWidth = 2;
    contextRef.current = context;
    context.scale(1, -1);
    context.translate(0, -height);
    drawAxes();

  }, [width, height, drawAxes]);

  const drawPoints = useCallback((points) => {
    const ctx = contextRef.current;
    // ADDED BY CHATGPT
    if (!ctx) return;
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  
    let lastPoint = null;
    for (const x in points) {
      const y = points[x];
      if (lastPoint) {
        //BELOW 4 LINES MODIFIED BY CHATGPT
        ctx.beginPath();
        ctx.moveTo(lastPoint.x - 1, height - lastPoint.y); // Adjust the x-coordinate and y-coordinate
        ctx.lineTo(x - 1, height - y); // Adjust the x-coordinate and y-coordinate
        ctx.stroke();        
      }
      lastPoint = { x, y };
    }

    //ADDED BY CHATGPT
    //lastPointRef.current = lastPoint; // Update the lastPointRef

    onPointsChange(points);
    drawAxes();
  
  }, [onPointsChange, height, drawAxes]);
  

  useEffect(() => {
    // Initialize points with a straight horizontal line in the middle of the canvas
    const initialPoints = {};
    const initialY =  0; //canvasRef.current.height / 2;
    for (let x = 0; x < canvasRef.current.width; x++) {
      initialPoints[x] = initialY;
    }
    setPoints(initialPoints);
    drawPoints(initialPoints);
  }, [drawPoints]);

  const interpolatePoints = (x1, y1, x2, y2) => {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.ceil(dist);
    const points = {};
  
    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      const x = x1 + dx * t;
      const y = y1 + dy * t;
      points[Math.floor(x)] = y;
    }
  
    return points;
  };  

  const startDrawing = (event) => {
    setDrawing(true);
    const { offsetX, offsetY } = event.nativeEvent;
    lastPointRef.current = { x: offsetX, y: offsetY };
  };
  
  

  const draw = (event) => {
    if (!drawing) return;
    const { offsetX, offsetY } = event.nativeEvent;
    const prevPoint = lastPointRef.current;
    const newPoints = interpolatePoints(prevPoint.x, prevPoint.y, offsetX, offsetY);
  
    setPoints((prevPoints) => {
      const updatedPoints = { ...prevPoints, ...newPoints };
      drawPoints(updatedPoints);
      return updatedPoints;
    });
    lastPointRef.current = { x: offsetX, y: offsetY };
  };
   

  const stopDrawing = () => {
    setDrawing(false);
  };
  

  return (
    <canvas
      onMouseDown={startDrawing}
      onMouseUp={stopDrawing}
      onMouseOut={stopDrawing}
      onMouseMove={draw}
      ref={canvasRef}
    />
  )
}

export default DrawingBoard;